// Structured error contract from the API.
// See docs/FRONTEND_ERROR_HANDLING.md for the full specification.

export interface FieldError {
  code: string;
  message: string;
  params?: Record<string, unknown> | null;
}

export interface ApiError {
  type?: string | null;
  title: string;
  status: number;
  detail?: string | null;
  instance?: string | null;
  code: string;
  traceId?: string | null;
  errors?: Record<string, FieldError[]> | null;
  // Dev-only diagnostics
  exceptionType?: string;
  stackTrace?: string;
  innerException?: string;
}

export function isApiError(value: unknown): value is ApiError {
  // Must have code (string) + status (number) + title (string).
  // The `title` check is what distinguishes a real ApiError body from an
  // AxiosError instance, which also has `code` (e.g. "ERR_BAD_REQUEST") and
  // `status` but no `title`.
  return (
    typeof value === 'object' &&
    value !== null &&
    'code' in value &&
    typeof (value as { code: unknown }).code === 'string' &&
    'status' in value &&
    typeof (value as { status: unknown }).status === 'number' &&
    'title' in value &&
    typeof (value as { title: unknown }).title === 'string'
  );
}
